export const palette = {
  black: '#000000',
  ink900: '#0B0B12',
  ink800: '#12121C',
  ink700: '#181824',
  ink600: '#1E1E2D',
  ink500: '#262638',
  ink400: '#2F2F44',
  // Lightest ink step. Reserved for interactive component boundaries, which need
  // 3:1 against their fill and their container (WCAG 1.4.11).
  ink200: '#62637A',

  grey400: '#8A8AA0',
  grey350: '#9999AE',
  grey300: '#A8A8BE',
  white: '#FFFFFF',
  slate400: '#7B8290',

  teal500: '#19E3CF',
  teal400: '#3FEBDA',

  red500: '#F0492E',
  red400: '#F76B54',
  // Deepened reds: destructive fills that must carry white text at 4.5:1.
  red600: '#DE361A',
  red700: '#C82E14',
  amber400: '#F5B03E',
  green500: '#33AE79',
  cyan400: '#22D3EE',

  canvasDark: '#0E0E16',
};
